import React, { useEffect, useState } from 'react';
import { ParamCardProps } from 'pages/CreateOrderPage/hooks/useFetchServiceParams';
import { AttachedPhoto } from 'pages/CreateOrderPage/types/OrderServiceItem';

export const useCalculateCardNumber = (category: number | string, list: ParamCardProps[] | AttachedPhoto[], listRef: React.RefObject<HTMLDivElement>, realCardWidth: number, page: number, setPage: React.Dispatch<React.SetStateAction<number>>, height: number, width: number, realCardHeight?: number, photoList?: AttachedPhoto[]) => {
  const [shownList, setShownList] = useState([] as ParamCardProps[] | AttachedPhoto[]);
  const [cardCount, setCardCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [shownPhotoList, setShownPhotoList] = useState([] as AttachedPhoto[]);
  // card width + margin
  const cardWidth = realCardWidth + 16;
  const cardHeight = (realCardHeight || 72) + 14;
  useEffect(() => {
    if (listRef.current) {
      const listWidth = listRef.current.offsetWidth;
      const listHeight = listRef.current.offsetHeight;
      const cardCountVar = Math.floor(listWidth / cardWidth) * Math.floor(listHeight / cardHeight) + 1;
      const pageCountVar = Math.ceil(list.length / cardCountVar);
      const shownListVar = list.slice((page - 1) * cardCountVar, page * cardCountVar);
      console.log('yo');
      console.log(page);
      if (page > pageCountVar && pageCountVar !== 0) setPage(pageCountVar);
      // update only if card count changed
      if (cardCountVar !== cardCount || pageCountVar !== pageCount || shownListVar !== shownList) {
        setCardCount(cardCountVar);
        setPageCount(pageCountVar);
        setShownList(shownListVar);
        console.log(shownListVar);
      }
    }
  }, [list, listRef, page, height, width, category]);
  useEffect(() => {
    if (photoList && listRef.current) {
      const listWidth = listRef.current.offsetWidth;
      const listHeight = listRef.current.offsetHeight;
      const cardCountVar = Math.floor(listWidth / cardWidth) * Math.floor(listHeight / cardHeight) + 1;
      const pageCountVar = Math.ceil((photoList.length) / cardCountVar);
      const shownListVar = photoList.slice((page - 1) * cardCountVar, page * cardCountVar);
      if (page > pageCountVar && pageCountVar !== 0) setPage(pageCountVar);
      // update only if card count changed
      if (cardCountVar !== cardCount || pageCountVar !== pageCount || shownListVar !== shownPhotoList) {
        setCardCount(cardCountVar);
        setPageCount(pageCountVar);
        setShownPhotoList(shownListVar);
      }
    }
  }, [photoList, listRef, page, height, width, category]);
  return { shownList, cardCount, pageCount, shownPhotoList };
};
